var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.818 5.203a1 1 0 011 1V21a1 1 0 01-1 1H4.27a1 1 0 01-1-1V6.203a1 1 0 011-1h9.548zM9.25 10.865c-.145-.152-.348-.153-.5 0-.148.147-1.402 1.463-1.508 1.575l-.007.008-.012.011-.012.014c-.243.263-.711.772-.711 1.411 0 .787.562 1.444 1.375 1.444.196 0 .373-.032.529-.091l-.36 1.513H9.96l-.364-1.526c.17.067.351.104.529.104.812 0 1.374-.656 1.375-1.444 0-.656-.493-1.178-.75-1.443l-1.5-1.576z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.721 2.494a1 1 0 011.225-.707l9.223 2.472a1 1 0 01.706 1.225l-3.83 14.293a1 1 0 01-1.224.707l-.019-.005V5.154a1 1 0 00-1-1H9.277l.444-1.66z",
    fill: "currentColor"
  })));
}
SvgPokerFilled.displayName = 'PokerFilled';
export default SvgPokerFilled;